import StorageItemInterface from "./interfaces/StorageItemInterface";

export default class StorageItem implements StorageItemInterface {
    protected value: string;

    protected expiresAt: number | null;

    constructor(value: string, expiresAt: number) {
        this.value = value;
        this.expiresAt = expiresAt || null;
    }

    public static fromString(data: string): StorageItem {
        let {value, expiresAt} = JSON.parse(data);
        return new StorageItem(value, expiresAt);
    }

    public serialize(): string {
        return JSON.stringify({
            value: this.value,
            expiresAt: this.expiresAt
        });
    }

    public isExpired(): boolean {
        return this.expiresAt !== null && this.expiresAt < (new Date()).getTime()
    }

    public getValue(): string {
        return this.value;
    }
}


// WEBPACK FOOTER //
// ./src/common/persistedState/storage/StorageItem.ts